import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

import { __ } from '@wordpress/i18n'
export default class strateTabsSliderComponent {
    constructor() {
        const sliderId = 'strate--tabs'
        const swiperContainer = `[data-slider="${sliderId}"]`

        if ($(swiperContainer).length > 0) {
            const options = {
                slidesPerView: 1,
                allowTouchMove: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                navigation: {
                    prevEl: `[data-slider-arrow-prev="${sliderId}"]`,
                    nextEl: `[data-slider-arrow-next="${sliderId}"]`,
                },
                pagination: {
                    el: `[data-slider-pagination="${sliderId}"]`,
                    clickable: true,
                    bulletClass: 'tabs__navigation__item',
                    bulletActiveClass: 'tabs__navigation__item--active',
                    renderBullet: (index, className) => `
                            <div class="${className}">
                                <div class="thumbnail">
                                    ${IRISCollectionCustomer.strate1PaginationData[index].image}
                                    <img class="bullet-decoration" src="${IRISCollectionCustomer.strate1ActiveBulletUrl}" alt="${__('decoration')}">
                                </div>
                                <span class="tabs__navigation__item__title">
                                    ${IRISCollectionCustomer.strate1PaginationData[index].title}
                                </span>
                            </div>
                        `,
                },
            }

            // needed wrapper
            $(`${swiperContainer} > .tab`)
                .addClass('swiper-slide')
                .wrapAll('<div class="swiper-wrapper"></div>')

            Swiper.create(swiperContainer, options).then()
        }
    }
}
